import React from 'react';
import NewsItem from './NewsItem';
import Link from 'next/link';

type NewsCardProps = {
  title: string;
  data: Article[];
  initialNumToRender: number;
  firstItemHighlight: boolean;
  firstItemVideo?: boolean;
  firstItemShowImage?: boolean;
  showImage?: boolean;
  itemLayout: 'highlight' | 'standard' | 'number';
  catLink: string;
};

const NewsCardList = ({
  title,
  data,
  initialNumToRender,
  firstItemHighlight,
  firstItemVideo,
  firstItemShowImage = true,
  showImage = true,
  itemLayout,
  catLink
}: NewsCardProps) => {
  const isFirstItemDifferent =
    firstItemHighlight ?? firstItemVideo ?? firstItemShowImage;
  const items = data?.slice(isFirstItemDifferent ? 1 : 0, initialNumToRender);
  const firstItem = isFirstItemDifferent ? data?.[0] : null;

  return (
    <div
      className='news-section-news-card'
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div className='news-section-news-card__header'>
        <div className='news-section-news-card__title'>{title}</div>
      </div>
      <div
        className='news-section-news-card__body'
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {firstItem && (
          <div className='news-section-news-card__first-item'>
            <NewsItem
              key={firstItem.fields.slug}
              itemIndex={1}
              article={firstItem}
              layout={firstItemHighlight ? 'highlight' : itemLayout}
              video={firstItemVideo ?? false}
              showImage={firstItemShowImage}
            />
          </div>
        )}
        <div
          className='news-section-news-card__other-items'
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly'
          }}
        >
          {items.map((item, index) => (
            <NewsItem
              key={item.fields.slug}
              itemIndex={index + 1}
              article={item}
              layout={itemLayout}
              video={firstItemVideo ?? false}
              showImage={showImage}
            />
          ))}
        </div>
      </div>
      <Link
        prefetch={false}
        href={catLink}
        className='news-section-news-card__footer'
      >
        <div className='news-section-news-card__footer-text'>View All &gt;</div>
      </Link>
    </div>
  );
};

export default NewsCardList;
